import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import CommonAppbar from '../components/common/CommonAppbar';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {URLS} from '../constants/appConstants';
import DeveloperInfo from '../components/common/DeveloperInfo';

export default function LanguageSelection() {
  const [age, setAge] = React.useState('10');
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const isSignInPage = searchParams.get('signIn') === 'true'

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  return (
    <>
      <CommonAppbar isMainPage={false} pageHeader={'Select language'}/>
      <DeveloperInfo> This screen should be visible only when we support multiple languages in the app </DeveloperInfo>
      <Box sx={{minWidth: 120}}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Display Language</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={age}
            label="Language"
            onChange={handleChange}
          >
            <MenuItem value={10}>English</MenuItem>
            <MenuItem value={20}>Tamil</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{mt: 2}}>
          <Button variant="contained"
                  onClick={() => navigate(`${isSignInPage ? `${URLS.CONTENT_LANGUAGE_SELECTION}?signIn=true` : URLS.PROFILE}`)}>
            Save
          </Button>
        </FormControl>

      </Box>
    </>
  );
}
